export const preAnestheticConsultation = {
	user_id: "",
	attendance_date: "",
	attendance_id: "",
	previous_anesthesia: "",
	description_previous_anesthesia: "",
	hemotransfusion: "",
	asa_classification: "",
	invasive_blood_pressure: "",
	diseases_or_symptoms: [] as string[],
	observations: "",
	user: {} as UserIdAndName,
};
